import { jwtDecode } from 'jwt-decode';

export const isAdmin = (currentUser) => {
	let result = false;
	if (currentUser && currentUser.roles.includes('ROLE_ADMIN')) {
		result = true;
	}

	return result;
};

export const isCoach = (currentUser) => {
	let result = false;
	if (currentUser && currentUser.roles.includes('ROLE_COACH')) {
		result = true;
	}

	return result;
};

export const isInstructor = (currentUser) => {
	return !!currentUser && currentUser.roles.includes('ROLE_INSTRUCTOR');
};

export const isClient = (currentUser) => {
	let result = false;
	if (currentUser && currentUser.roles.includes('ROLE_CLIENT')) {
		result = true;
	}

	return result;
};

export const isRoleTienda = (currentUser) => {
	let result = false;
	if (currentUser && currentUser.roles.includes('ROLE_TIENDA')) {
		result = true;
	}

	return result;
};

export const isTokenExpired = (currentUser) => {
	try {
		const decodedToken = jwtDecode(currentUser.accessToken);
		if (!decodedToken.exp) {
			return true;
		}
		const currentTime = Date.now() / 1000;
		return decodedToken.exp < currentTime;
	} catch (error) {
		return true;
	}
};
